module.exports = __webpack_public_path__ + "img/led_in_switch_75.1c19c4c2.png";